module.exports = __webpack_public_path__ + "static/img/questionnaire-dialog-icon.4c3a288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionnaire/questionnaire-dialog-icon.png
// module id = chXG
// module chunks = 1